import { render } from "./AnnotationTool.vue?vue&type=template&id=004e710e&scoped=true"
import script from "./AnnotationTool.vue?vue&type=script&lang=js"
export * from "./AnnotationTool.vue?vue&type=script&lang=js"

import "./AnnotationTool.vue?vue&type=style&index=0&id=004e710e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004e710e"]])

export default __exports__